module.exports = __webpack_public_path__ + "media/images/lb/929-17ca7d3e16f58e3afa545d740362208e.svg";